import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Parallax } from "react-parallax";
import Navbar from '../layout/Navbar';
import Preloader from '../layout/preloader';
import Footer from '../section-pages/footer';
import ScrollToTopBtn from '../layout/ScrollToTop';
import { createGlobalStyle } from 'styled-components';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import AlunoFormulario from '../section-pages/cadastro-aluno-formulario';
import AlunoEventos from '../section-pages/cadastro-aluno-evento';
import MinhaAnuidade from '../section-pages/cadastro-aluno-anuidade';
import Financeiro from '../section-pages/cadastro-aluno-financeiro';

const image1 ="./img/background/5.webp";
const GlobalStyles = createGlobalStyle`
  .react-parallax-bgimage {
    transform: translate3d(-50%, 0, 0px) !important;
  }
`;

export default function Home() {   
    useEffect(() => {
      if (typeof window !== 'undefined') {
          const loader = document.getElementById('mainpreloader');
          if (loader)
          setTimeout(() => {
            loader.classList.add("fadeOut");
            loader.style.display = 'none';
          }, 600)
      }
    }, []);

    return (
        <>
            {/* HEAD */}
            <Helmet>
                <link rel="icon" href="./img/icon.png" />
                <title>Fetron - Federação de Taekwondô de Rondônia</title>
            </Helmet>

            <GlobalStyles/>

            {/* LOADER */}
            <div id='mainpreloader'>
                <Preloader/>
            </div>

            {/* MENU */}
            <div className="home dark-scheme">
                <header id="header-wrap">
                    <Navbar />
                </header>

                {/* section */}
                <Parallax className="" bgImage={image1} strength={5}>  
                    <section className="no-bg">
                        <div className="container z-9">
                            <div className="row align-items-center">
                                <div className="col-lg-12">
                                    <div className="p-5 rounded-10 shadow-soft bg-white-1">
                                    <Tabs>
                                        <TabList>
                                            <Tab>Financeiro</Tab>
                                            <Tab>Anuidade</Tab>
                                            <Tab>Meus Dados</Tab>
                                            <Tab>Eventos</Tab>
                                        </TabList>
                                        <TabPanel>
                                            <Financeiro />
                                        </TabPanel>
                                        <TabPanel>
                                            <MinhaAnuidade />
                                        </TabPanel>
                                        <TabPanel>
                                            <AlunoFormulario />
                                        </TabPanel>
                                        <TabPanel>
                                            <AlunoEventos />
                                        </TabPanel>
                                    </Tabs>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </Parallax>

                {/* footer */}
                <Footer/>

            </div>
            <ScrollToTopBtn />
        </>
  )
}
